import React from "react";

// Stylized hawk / eagle silhouette — used as ambient mythic motif
export const WingedBird = ({ size = 100, color = "#C9A84C", opacity = 0.18, flipped = false, className = "" }) => (
  <svg
    width={size}
    height={size * 0.45}
    viewBox="0 0 200 90"
    className={className}
    style={{ opacity, transform: flipped ? "scaleX(-1)" : undefined }}
    aria-hidden="true"
  >
    {/* Wing arc — soaring bird */}
    <path
      d="M 10 60 Q 50 10 100 45 Q 150 10 190 60"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M 35 55 Q 65 30 100 50"
      fill="none"
      stroke={color}
      strokeWidth="0.8"
      opacity="0.6"
      strokeLinecap="round"
    />
    <path
      d="M 100 50 Q 135 30 165 55"
      fill="none"
      stroke={color}
      strokeWidth="0.8"
      opacity="0.6"
      strokeLinecap="round"
    />
    {/* Body */}
    <ellipse cx="100" cy="50" rx="5" ry="2.2" fill={color} />
  </svg>
);

// Ziggurat city silhouette — horizon landscape (Mesopotamian skyline)
export const ZigguratHorizon = ({ width = 1600, height = 120, color = "#1a3a6a", className = "" }) => (
  <svg
    width="100%"
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    preserveAspectRatio="xMidYMax slice"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="zg-fade" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor={color} stopOpacity="0.35" />
        <stop offset="100%" stopColor={color} stopOpacity="0.95" />
      </linearGradient>
    </defs>
    <path
      fill="url(#zg-fade)"
      d={`
        M 0 ${height}
        L 0 95
        L 80 95 L 80 80 L 140 80 L 140 65 L 210 65 L 210 50 L 270 50 L 270 65 L 330 65 L 330 80 L 400 80 L 400 95
        L 480 95 L 480 78 L 530 78 L 530 60 L 580 60 L 580 42 L 640 42 L 640 60 L 690 60 L 690 78 L 740 78 L 740 95
        L 820 95 L 820 70 L 870 70 L 870 50 L 920 50 L 920 32 L 980 32 L 980 50 L 1030 50 L 1030 70 L 1080 70 L 1080 95
        L 1160 95 L 1160 80 L 1220 80 L 1220 65 L 1280 65 L 1280 50 L 1340 50 L 1340 65 L 1400 65 L 1400 80 L 1460 80 L 1460 95
        L ${width} 95
        L ${width} ${height}
        Z
      `}
    />
    {/* Tiny star points on top of tallest ziggurats */}
    <circle cx="240" cy="50" r="1.2" fill="#C9A84C" opacity="0.6" />
    <circle cx="610" cy="42" r="1.4" fill="#E8C97A" opacity="0.8" />
    <circle cx="950" cy="32" r="1.4" fill="#E8C97A" opacity="0.8" />
    <circle cx="1310" cy="50" r="1.2" fill="#C9A84C" opacity="0.6" />
  </svg>
);
